import { call } from "@redux-saga/core/effects"
import doValidate from "../../../client/validation/doValidate"

function* tryGetValidData(dataSchema, data) {
    try {
        return yield call(doValidate, dataSchema, data)
    } catch(validationE) {
        yield console.log(validationE.name)
        yield console.log( validationE.errors)
        throw new Error(validationE.name)
    }
}

export default tryGetValidData